import React, { useEffect, useState } from "react";
import { VALIDATIONS, VALIDATIONS_TEXT } from "../../../app-constants";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import TekLoader from "../../images/Tek-Spinner.gif";

function ContentFrom({ rtl }) {
  
  const getBaseUrl = () => {
    if (
      typeof window !== "undefined" &&
      (window.location.href.includes(
        "https://staging-tekrevol.tekstagearea.com"
      ) ||
        window.location.href.includes("http://localhost:8000") ||
        window.location.href.includes("http://localhost:9000"))
    ) {
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    } else {
      // return "https://tekrevol.tekstagearea.com/api/v1/contact-form";
      return "https://tekrevol-form.tekstagearea.com/contact-form.php";
    }
  };


  const className = rtl ? "content_form rtl-style" : "content_form";
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const [Success, SetSuccess] = useState(false);
  const [Loading, SetLoading] = useState(false);
  const onSubmit = async (data) => {
    const url = window.location.href;
    data.form_path = url.split("?")[0];
    SetLoading(true);

    const baseUrl = getBaseUrl(); // Get the base URL
    const response = await axios.post(baseUrl, data);

    // const response = await axios.post(
    //   `https://tekrevol.tekstagearea.com/api/v1/contact-form`,
    //   data
    // );

    SetSuccess(true);
    setTimeout(() => {
      SetSuccess(false);
    }, 2000);
    SetLoading(false);
    reset({
      name: "",
      email: "",
      phone: "",
      nda: "",
      description: "",
    });
  };
  return (
    <div className={className}>
      <Form
        className="content_form_inner"
        onSubmit={handleSubmit(onSubmit)}
        method="POST"
      >
        <Form.Group className="from_item">
          <Form.Control
            type="text"
            placeholder="الاسم الكامل"
            name="name"
            {...register("name", {
              pattern: {
                value: /^[A-Za-z\s]+$/,
                message: "يمكن أن يحتوي الاسم على الحروف والمسافات فقط.",
              },
              maxLength: {
                value: VALIDATIONS.NAME,
                message: "الحد الأقصى للطول هو 20",
              },
              required: {
                value: true,
                message: "الاسم مطلوب",
              },
            })}
          />
          {errors.name && (
            <span className="error_tek">{errors.name?.message}</span>
          )}
        </Form.Group>
        <Form.Group className="from_item">
          <Form.Control
            type="email"
            placeholder="البريد الإلكتروني"
            name="email"
            {...register("email", {
              maxLength: {
                value: VALIDATIONS.EMAIL,
                message: "الحد الأقصى للطول هو 30",
              },
              required: {
                value: true,
                message: "البريد الالكتروني مطلوب",
              },
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "تنسيق البريد الإلكتروني غير صالح",
              },
            })}
          />
          {errors.email && (
            <span className="error_tek">{errors.email?.message}</span>
          )}
        </Form.Group>
        <Form.Group className="from_item">
          <Form.Control
            type="tel"
            placeholder="الرقم"
            name="phone"
            {...register("phone", {
              pattern: {
                value: /^\+?\d*$/,
                message: "رقم الهاتف يمكن أن يحتوي على أرقام فقط.",
              },
              minLength: {
                value: VALIDATIONS.PHONE_MIN,
                message: "الحد الأدنى للطول هو 11",
              },
              maxLength: {
                value: VALIDATIONS.PHONE_MAX,
                message: "الحد الأقصى للطول هو 15",
              },
              required: {
                value: true,
                message: "رقم الاتصال مطلوب",
              },
            })}
          />
          {errors.phone && (
            <span className="error_tek">{errors.phone?.message}</span>
          )}
        </Form.Group>

        <Form.Group className="from_item">
          <Form.Control
            as="textarea"
            rows={4}
            name="descriptions"
            placeholder="صف احتياجات مشروعك."
            {...register("description", {
              maxLength: {
                value: VALIDATIONS.DESCRIPTION_MAX,
                message: "الحد الأقصى للطول هو 255",
              },
              required: {
                value: true,
                message: "الوصف مطلوب",
              },
            })}
          />
          {errors.description && (
            <span className="error_tek">{errors.description?.message}</span>
          )}
        </Form.Group>
        {!Loading ? (
          <Button variant="primary" className="btn_submit" type="submit">
            تواصل معنا
          </Button>
        ) : (
          <img
            src={TekLoader}
            alt="img_looder"
            className="img-fluid looder_img"
          />
        )}
      </Form>
      {Success ? (
        <div className="alert-success">شكرًا لرسالتك. تم إرسالها.</div>
      ) : (
        ""
      )}
    </div>
  );
}

export default ContentFrom;
